import { AnalysisStatus, QC_STATUS } from '@/enums';

export const analysisStatusColor: {
  [key in AnalysisStatus]: {
    textColor: string;
    color: string;
  };
} = {
  ANALYSING: {
    textColor: '#ffac00',
    color: '#fff9eb',
  },
  ANALYSIS_COMPLETED: {
    textColor: '#00ab00',
    color: '#ebf9eb',
  },
  TO_BE_ANALYSED: {
    textColor: '#007ae7',
    color: '#ebf5fb',
  },
  CAUTION: {
    textColor: '#ff634e',
    color: '#fff3f1',
  },
};

export const QC_STATUS_COLOR: {
  [key in QC_STATUS]: {
    textColor: string;
    color: string;
  };
} = {
  PROCESSING: {
    textColor: '#007ae7',
    color: '#ebf5fb',
  },
  PASSED: {
    textColor: '#00ab00',
    color: '#ebf9eb',
  },
  FAILED: {
    textColor: '#ff634e',
    color: '#fff3f1',
  },
};
